<div class="flex flex-col rounded-md border border-solid border-subtle p-3">
  <div class="flex cursor-pointer items-stretch gap-3" role="button" (click)="toggled.emit()">
    <div class="flex w-4 flex-col gap-0.5 overflow-hidden rounded-md">
      @if (remainingPercentage < 100) {
        <div class="flex-1 bg-alt"></div>
      }
      @if (remainingPercentage > 0) {
        <div class="bg-brand" [ngStyle]="{ height: remainingPercentage + '%' }"></div>
      }
    </div>
    <div class="flex flex-1 flex-col">
      <p class="m-0 text-sm font-bold text-default">{{ balance.timeOffBalanceName }}</p>
      <h5 class="m-0 text-2xl font-bold text-default">
        {{ balance.total | decimalToDurationFormat: balance.unit : durationOptions }}
      </h5>
      <p class="m-0 text-xs font-medium text-support">
        {{ 'Remaining' | translate }}
      </p>
    </div>
    <sb-icon
      name="chevron-down"
      class="self-center transition-transform ease-in-out"
      [ngClass]="{ '-rotate-180': isActive }"
    >
    </sb-icon>
  </div>

  @if (expiries?.length) {
    <div class="mt-3 flex flex-col gap-3">
      @for (expiry of expiries; track expiry.date) {
        <sb-notice variant="warning" [size]="'sm'">
          <h5 sbNoticeHeader>{{ ('To Expire' | translate) + ': ' + expiry.expireAmount }}</h5>
          <p>{{ ('Use before' | translate) + ' ' + expiry.formattedDate }}</p>
          <button sbNoticeAction type="button" (click)="redirectToHelpCenter()">{{ 'Learn more' | translate }}</button>
        </sb-notice>
      }
    </div>
  }

  <div
    class="grid transition-collapse duration-300 ease-in-out"
    [ngClass]="{ 'grid-rows-collapse': !isActive, 'mt-3 grid-rows-collapse-expanded': isActive }"
  >
    <div class="flex flex-col gap-3 overflow-hidden">
      @for (partial of partialBalances; track $index) {
        <time-off-partial-balance [employee]="employee" [partial]="partial"> </time-off-partial-balance>
      }
      @if (expired?.items?.length) {
        <time-off-partial-balance [employee]="employee" [partial]="expired"> </time-off-partial-balance>
      }
      <hr sbDivider />
      <p class="m-0 flex items-center gap-2 text-sm font-bold text-default">
        <span class="size-3 rounded-base bg-brand"></span>
        <span class="flex-1">{{ 'Remaining' | translate }}</span>
        {{ balance.total | decimalToDurationFormat: balance.unit : durationOptions }}
      </p>
    </div>
  </div>
</div>
